import React from 'react';
import { MapPin, Heart, ArrowLeft, RotateCcw } from 'lucide-react';
import { OptimizedFloralCard } from './ui/OptimizedComponents';
import { FloralErrorBoundary } from './ui/FloralCard';

type Language = 'english' | 'iban';

interface NotAttendingConfirmationProps {
  guestName: string;
  onStartNewRSVP?: () => void;
  selectedLanguage?: Language;
}

const NotAttendingConfirmation: React.FC<NotAttendingConfirmationProps> = ({ guestName, onStartNewRSVP, selectedLanguage = 'english' }) => {
  // Translation objects
  const translations = {
    english: {
      thankYou: 'Thank You',
      message1: "We're sorry you can't make it to our special day, but we appreciate you letting us know.",
      message2: "We'll miss having you there!",
      changeMessage: "If your plans change and you find that you're able to attend after all, please don't hesitate to reach out to us directly.",
      startNewRSVP: 'Start New RSVP'
    },
    iban: {
      thankYou: 'Terima Kasih',
      message1: 'Sayau amat kita enda ulih datai ngagai hari nya, tang kami beterima kasih laban nuan udah madahka kami.',
      message2: 'Betemu baru!',
      changeMessage: 'Enti pelan nuan berubah lalu nuan ulih datai, anang kakang ati terus ngiga kami.',
      startNewRSVP: 'Berengkah Baru'
    }
  };

  const t = translations[selectedLanguage];

  return (
    <FloralErrorBoundary>
      <div className="py-8 sm:py-12 px-4 sm:px-6 lg:px-8 relative">
        {/* Corner decorations with flowers */}
        <div className="floral-corner-decoration floral-corner-top-left"></div>
        <div className="floral-corner-decoration floral-corner-top-right"></div>
        <div className="floral-corner-decoration floral-corner-bottom-left"></div>
        <div className="floral-corner-decoration floral-corner-bottom-right"></div>

        <div className="max-w-2xl mx-auto relative z-10">
          <OptimizedFloralCard variant="elevated" padding="xl" className="text-center" showCornerDecorations={false}>
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />
            </div>

            <h2 className="floral-title text-2xl sm:text-3xl mb-4 sm:mb-6">{t.thankYou}, {guestName}!</h2>

            <div className="flex justify-center mb-4 sm:mb-6">
              <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-blue-400 mx-1" />
              <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-green-500 mx-1" />
              <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-blue-400 mx-1" />
            </div>

            <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              {t.message1} {t.message2}
            </p>
          </OptimizedFloralCard>
        </div>
      </div>
    </FloralErrorBoundary>
  );
};

export default NotAttendingConfirmation;
